import React, { useMemo } from 'react';

import BiDashboardHeader from 'components/tools/bi-dashboard/BiDashboardHeader';
import BiDashboardTable from 'components/tools/bi-dashboard/BiDashboardTable';
import FiltersPanel from 'components/tools/bi-dashboard/FiltersPanel';
import { BiDashboardPageStore, BiDashboardPageStoreContext } from 'store/pages/tools/bi-groups-dashboard/pageStore';
import RowActionModals from 'components/tools/bi-dashboard/RowActionModals';
import { NoSidebarPageLayout } from '@insurancemenu/imenu-components-lib';

const BiDashboardPage: React.FC = () => {
  const pageStore = useMemo(() => new BiDashboardPageStore(), []);
  return (
    <BiDashboardPageStoreContext.Provider value={pageStore}>
      <NoSidebarPageLayout pageHeader={<BiDashboardHeader />} pageFooter={null} contentWidth="wide">
        <FiltersPanel />
        <RowActionModals />
        <BiDashboardTable />
      </NoSidebarPageLayout>
    </BiDashboardPageStoreContext.Provider>
  );
};

export default BiDashboardPage;
